export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "process_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reportes del proceso"])},
          "containers_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reportes por contenedor"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of process"])},
          "process_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Process reports"])},
          "containers_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container reports"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])}
        }
      }
    }
  })
}